import React from 'react'
import { gql } from '@apollo/client'
import { useMutation } from '@ztechapps/common.hook'
import { cartFragment } from '../graphql'
import type { UseCommonCartProps } from '../type'
import type { Order, RemoveToCartArgs } from '@ztechapps/common.contract'

export const buildOrderRemoveToCartQuery = (fragment: string) => {
  return gql`
  mutation orderRemoveToCart($input: RemoveToCartArgs!) {
    orderRemoveToCart(input: $input) {
        _id
       ${fragment}
    }
  }
`
}

const orderRemoveToCartQuery = buildOrderRemoveToCartQuery(cartFragment)

export const useRemoveToCart = ({ validate, query, ...rest }: UseCommonCartProps = {}) => {
  const [onRemove, , { loading, error }] = useMutation<{ orderRemoveToCart: Order }, RemoveToCartArgs>({
    query: query ?? orderRemoveToCartQuery,
    ...rest,
  })

  const removeToCart = React.useCallback(
    ({ itemId, orderId }) => {
      validate?.()

      //do the submission here
      const input = {
        orderId,
        itemId,
      }

      return onRemove({ input })
    },
    [onRemove, validate]
  )

  return { removeToCart, loading, error }
}
